import './rangepdf.scss';

import React, { useCallback, useContext, useEffect, useLayoutEffect, useRef, useState } from 'react';
import { FormattedMessage, FormattedNumber, useIntl } from 'react-intl';
import { useHistory, useLocation, useParams } from 'react-router-dom';

import _ from 'underscore';
import CONFIG from '../../../common/config';
import API from '../../../common/constants/api.constants';
import RANGEPDF from '../../../common/constants/rangepdf.constants';
import ROUTES from '../../../common/constants/routes.constants';
import { KiaContext } from '../../../common/context/main.context';
import { getDealers } from '../../../common/services/dealers.service';
import GTM from '../../../common/services/gtm.service';
import { submitPdfRangeCodeSubmission, submitPdfRangeHints, submitPdfRangeTestDrive } from '../../../common/services/pdfRangeEv2.service';
import querystring from '../../../common/utils/querystring.utils';
import Button from '../../01_atoms/button/Button';
import Input from '../../01_atoms/form/Input';
import Select from '../../01_atoms/form/Select';
import Info from '../../02_molecules/info/Info';
import Loading from '../../02_molecules/loading/Loading';
import Page from '../../04_layouts/page/Page';

const RANGEPDFMODEL = {
  code: '',
  address_country: '',
  car_model: '',
  gender: '',
  first_name: '',
  last_name: '',
  email: '',
  phone_number: '',
  company: '',
  dealer: '',
  dealer_code: '',
  location: '',
  language: '',
  source: '',
  keep_informed: 0,
  accept_privacy: 0,
  consent_statement: '',
  campaign_code: '',
  is_b2c: 0,
};

// Initialize Google Places Autocomplete service
let autocompleteService = null;

const FORM_PANEL_FADE_MS = 220;
/** Mobile only: after scroll-to-top, wait before scrolling to the form anchor. */
const MOBILE_SCROLL_TO_FORM_AFTER_MS = 400;

export default function Rangepdf() {
  const {
    currentLocale,
    prefix,
    dealer,
    clearDealer,
    cars,
    isB2c,
    country,
    showPromo,
  } = useContext(KiaContext);
  const location = useLocation();

  const history = useHistory();
  const params = useParams();
  const form = useRef();
  const formTopAnchorRef = useRef();
  const voucherLink = useRef();
  const rangepdfPrevSourceRef = useRef(params.source);

  const intl = useIntl();

  // @todo check in feb to update to better solution
  const month = new Date().getMonth() + 1;
  let day = new Date().getDate();
  let showOther = month === 2;

  if (country.id === 'lu' && day < 4) {
    showOther = false;
  }

  let voucherUrl = intl.formatMessage({ id: 'promo.contact.voucherlink' });
  if (showOther) {
    voucherUrl = intl.formatMessage({ id: 'promo.contact.voucherlink.feb' });
  }

  /** URL is the only tab source — avoids one-frame mismatch with local state + history.replace (broken layout / scroll). */
  const source = params.source;
  const [selectedDealer, setSelectedDealer] = useState(dealer);
  const [dealers, setDealers] = useState([]);
  const [valid, setValid] = useState(false);
  const [sending, setSending] = useState(false);
  const [success, setSuccess] = useState(false);
  const [failed, setFailed] = useState(false);
  const [predictions, setPredictions] = useState([]);
  const [prediction, setPrediction] = useState(null);
  const [carPlaceholderShown, setCarPlaceholderShown] = useState(false);
  const [genderPlaceholderShown, setGenderPlaceholderShown] = useState(false);
  const [isDesktop, setIsDesktop] = useState(false);
  const mediaQuery = '(min-width: 992px)';
  const [renderedSource, setRenderedSource] = useState(() => params.source);
  const [formPanelVisible, setFormPanelVisible] = useState(true);

  const CARS = [
    { value: 'EV2', label: intl.formatMessage({ id: 'contact.cars.ev2' }), gtm: 'ev2', model: 'ev2', visual: 'ev2', testdrive: true }

  ];
  const STINGER = CARS.find(car => car.value === 'Stinger');
  const EV9 = CARS.find(car => car.value === 'EV9');
  const EV3 = CARS.find(car => car.value === 'EV3');
  const PV5Cargo = CARS.find(car => car.value === 'PV5 Cargo');

  let _model;
  if (location.search) {
    const search = querystring.decode(location.search);

    if (search.model) {
      _model = search.model;
    }
  }
  const [model, setModel] = useState(_model);
  const [formData, setFormData] = useState({ ...RANGEPDFMODEL, is_b2c: isB2c ? 1 : 0 });
  let selectedCar = cars.find((car) => car.slug === CARS.find(car => car.value === formData.car_model)?.visual);
  // console.log("isB2c", isB2c);
  // console.log("CARS", CARS);
  // console.log("selectedCar", selectedCar);
  // const showBackgroundImage = selectedCar?.image && isDesktop;
  const showBackgroundImage = isDesktop;


  const genders = [
    {
      value: '',
      label: intl.formatMessage({ id: 'gender.title' }),
    },
    {
      value: 'M',
      label: intl.formatMessage({ id: 'gender.male' }),
    },
    {
      value: 'F',
      label: intl.formatMessage({ id: 'gender.female' }),
    },
  ];

  const carsOptions = [
    {
      value: '',
      label: intl.formatMessage({ id: 'contact.cars.select' }),
    },
    ...CARS.map(car => ({ value: car.value, label: car.label }))
  ];

  const [filteredCars, setFilteredCars] = useState([...carsOptions]);

  // @todo: remove when ev3 testdrive is available
  const filterCars = (tab = params.source) => {
    if (tab === RANGEPDF.testdrive) {
      // Filter out cars that don't have testdrive available
      const testdriveCars = carsOptions.filter(car => {
        if (car.value === '') return true; // Keep the "Select" option
        const carData = CARS.find(c => c.value === car.value);
        return carData && carData.testdrive;
      });
      setFilteredCars(testdriveCars);
    } else {
      setFilteredCars([...carsOptions]);
    }
  };

  const onChange = (e) => {
    const { name, value } = e.target;

    if (name === "car_model") {
      if (value === "") setCarPlaceholderShown(true);
      if (value !== "") setCarPlaceholderShown(false);
    }

    if (name === "gender") {
      if (value === "") setGenderPlaceholderShown(true);
      if (value !== "") setGenderPlaceholderShown(false);
    }

    setFormData(_formData => ({
      ..._formData,
      [name]: value,
    }));

    setSuccess(false);
    setFailed(false);
  };

  const onSourceChange = (e) => {
    const { value, dataset: { route } } = e.target;

    history.replace(route);

    const code = RANGEPDF.codes[value];

    // if (selectedCar && selectedCar.slug === EV3.model && value === RANGEPDF.testdrive) {
    //   formData.car_model = '';
    // }
    filterCars(value);

    onChange(e);

    const trackPayload = {
      dlCategory: 'Form',
      dlAction: 'Toggle',
      dlLabel: value,
    };

    if (formData.car_model) {
      trackPayload.dlModel = formData.car_model;
    }

    GTM.track(trackPayload);

    const newFormData = {
      ...formData,
      source: RANGEPDF.values[value],
      campaign_code: code,
    }

    // if (value === RANGEPDF.testdrive) delete newFormData.code
    // if (value === RANGEPDF.code) newFormData.code = 1
    // if (value === RANGEPDF.hints) newFormData.code = 0

    setFormData(newFormData);
  };

  const getPredictions = (payload) => {
    try {
      if (CONFIG.DEBUG) { console.log('get predictions', payload); }

      if (!autocompleteService) {
        if (CONFIG.DEBUG) { console.error('Google Places Autocomplete service not available'); }
        return;
      }

      autocompleteService.getPlacePredictions({
        input: payload.value,
        componentRestrictions: {
          country: ['be', 'lu'],
        },
        language: currentLocale.slug,
        types: ['(regions)']
      }, (predictions, status) => {
        if (status === window.google.maps.places.PlacesServiceStatus.OK && predictions) {

          // Get place details for each prediction to get coordinates
          const promises = predictions.map(prediction => {
            return new Promise((resolve) => {
              const placesService = new window.google.maps.places.PlacesService(document.createElement('div'));
              placesService.getDetails({
                placeId: prediction.place_id,
                fields: ['geometry', 'formatted_address']
              }, (place, placeStatus) => {
                if (placeStatus === window.google.maps.places.PlacesServiceStatus.OK && place && place.geometry) {
                  resolve({
                    description: prediction.description,
                    location: {
                      lat: place.geometry.location.lat(),
                      lng: place.geometry.location.lng()
                    },
                    place_id: prediction.place_id
                  });
                } else {
                  // Fallback: use prediction without coordinates
                  resolve({
                    description: prediction.description,
                    location: null,
                    place_id: prediction.place_id
                  });
                }
              });
            });
          });

          // Wait for all place details to be fetched
          Promise.all(promises).then(transformedPredictions => {
            setPredictions(transformedPredictions.filter(pred => pred.location !== null));
          });
        } else {
          if (CONFIG.DEBUG) { console.error('Google Places API error:', status); }
          setPredictions([]);
        }
      });
    } catch (e) {
      if (CONFIG.DEBUG) { console.error(e); }
    }
  };

  const debouncedgetPredictions = useCallback(_.debounce(getPredictions, 300, false), []);

  const onLocationChange = (e) => {
    const { value } = e.target;

    if (CONFIG.DEBUG) { console.log('location change', value); }
    onChange(e);

    if (selectedDealer || dealers.length) {
      setSelectedDealer(null);
      setDealers([]);
      setPrediction('');
      setPredictions([]);

      setFormData({
        ...formData,
        dealer: '',
        dealer_code: '',
        location: value,
      });
    }

    if (!value || value.length < 2) {
      setPredictions([]);
      setPrediction('');
      return;
    }

    debouncedgetPredictions({ value });
  };

  const onPredictionClick = (prediction) => {
    setFormData({
      ...formData,
      location: prediction.description,
    });

    setPrediction(prediction);
    setPredictions([]);
  };

  const getDealersFromLocation = async (location, car_model) => {
    if (CONFIG.DEBUG) { console.log('get dealers', location); }

    // Check if we have valid coordinates
    if (!location || !location.lat || !location.lng) {
      if (CONFIG.DEBUG) { console.error('No valid coordinates for dealer search'); }
      return;
    }

    const response = await getDealers({
      ...location,
      car_model: car_model,
    });

    if (CONFIG.DEBUG) { console.log('received dealers', response.features); }

    let { features } = response;

    if (formData.car_model && STINGER && formData.car_model === STINGER.value) {
      features = [...features].filter(feature => !feature.properties.types || feature.properties.types.indexOf('stinger') >= 0);
      if (CONFIG.DEBUG) { console.log('limit only stinger centers', model, response.features, features); }
    }

    if (formData.car_model && EV9 && formData.car_model === EV9.value) {
      features = [...features].filter(feature => !feature.properties.types?.includes('hide_ev9'));
      if (CONFIG.DEBUG) { console.log('limit only EV9 resellers', formData.car_model, features); }
    }

    let dealers = features.slice(0, CONFIG.MAX_DEALERS);

    // Hardcode swap for Genk location
    const locationName = formData.location || '';
    if (locationName.toLowerCase().includes('genk')) {
      const lumensIndex = dealers.findIndex(dealer =>
        dealer.properties.name && dealer.properties.name.includes('Kia Lumens Genk & Oost')
      );
      const vanMosselIndex = dealers.findIndex(dealer =>
        dealer.properties.name && dealer.properties.name.includes('Van Mossel Kia Hasselt')
      );

      if (lumensIndex !== -1 && vanMosselIndex !== -1) {
        // Ensure Lumens is above Van Mossel - swap if needed
        if (lumensIndex > vanMosselIndex) {
          // Swap positions: move Lumens to top, Van Mossel down
          const temp = dealers[lumensIndex];
          dealers[lumensIndex] = dealers[vanMosselIndex];
          dealers[vanMosselIndex] = temp;
        }
      }
    }

    if (CONFIG.DEBUG) { console.log('limit dealers', dealers); }

    setDealers(dealers);
  };

  const onDealerClick = (dealer) => {
    setSelectedDealer(dealer);
  };

  const onCheck = (e) => {
    const { name, checked } = e.target;

    setFormData({
      ...formData,
      [name]: checked ? 1 : 0,
    });

    setSuccess(false);
    setFailed(false);
  };

  const onSubmit = async (e) => {
    e.preventDefault();

    const { target } = e;

    setValid(false);
    setSending(true);

    const data = {
      ...formData,
    };

    // if (data.car_model === 'Sorento1' || data.car_model === 'Sorento2') {
    //   data.car_model = 'Sorento';
    // }

    if (CONFIG.DEBUG) { console.log('submit form', target.checkValidity(), data); }

    if (!target.checkValidity()) {
      return;
    }

    setSuccess(false);
    setFailed(false);
    setSending(true);

    try {
      let response;
      const optin = Boolean(Number(data.keep_informed));
      console.log("optin", optin);
      if (source === RANGEPDF.hints) {
        response = await submitPdfRangeHints({
          first_name: formData.first_name,
          last_name: formData.last_name,
          email: formData.email,
          optin,
          language: currentLocale.language,
        });
      } else if (source === RANGEPDF.testdrive) {
        response = await submitPdfRangeTestDrive({
          gender: formData.gender,
          first_name: formData.first_name,
          last_name: formData.last_name,
          email: formData.email,
          phone: formData.phone_number,
          company: formData.company ? formData.company : null,
          postal_code: formData.location ? formData.location : null,
          dealer: formData.dealer ? formData.dealer : null,
          dealer_code: formData.dealer_code ? formData.dealer_code : null,
          optin,
          language: currentLocale.language,
        });
      } else if (source === RANGEPDF.code) {
        response = await submitPdfRangeCodeSubmission({
          code: formData.code,
          gender: formData.gender,
          first_name: formData.first_name,
          last_name: formData.last_name,
          email: formData.email,
          phone: formData.phone_number,
          optin,
          language: currentLocale.language,
        });
      }


      if (response?.status === API.success) {
        const gtm_model = CARS.find(car => car.value === formData.car_model) || {};

        GTM.track({
          dlCategory: 'Form',
          dlAction: 'Submit',
          dlLabel: source,
          dlModel: gtm_model.gtm,
          dlFormCarModel: formData.car_model,
        });

        setSelectedDealer(null);
        setDealers([]);

        setSuccess(true);
      } else {
        if (CONFIG.DEBUG) { console.error('rangepdf submit rejected', response); }
        setFailed(true);
      }
    } catch (err) {
      console.error('rangepdf submit', err);
      setFailed(true);
    } finally {
      setSending(false);
    }
  };

  const resetDealer = () => {
    setFormData(_formData => ({
      ..._formData,
      dealer: '',
      dealer_code: '',
      location: '',
    }));
    setSelectedDealer(null);
    setDealers([]);
    setPrediction(null);
    setPredictions([]);

    clearDealer();
  };

  const reset = () => {
    const _source = RANGEPDF.values[params.source];
    const _code = RANGEPDF.codes[params.source];

    const payload = {
      ...RANGEPDFMODEL,
      source: _source,
      language: currentLocale.language,
      address_country: currentLocale.country,
      campaign_code: _code,
      consent_statement: intl.formatMessage({ id: 'contact.optin' }),
      is_b2c: isB2c ? 1 : 0,
    };

    if (selectedDealer) {
      const { properties: { name, user_properties: { sap_dealer_code } } } = selectedDealer;
      payload.dealer = name;
      payload.dealer_code = sap_dealer_code;
    }

    // if (params.source === RANGEPDF.code) payload.code = 1
    // if (params.source === RANGEPDF.hints) payload.code = 0

    if (location.search) {
      const search = querystring.decode(location.search);

      if (search.model) {
        setModel(search.model);

        // Prefer exact match on model first so ?model=k4 selects K4, not K4 SW (avoid substring match)
        const carsearch = CARS.find(car => car.model === search.model) || CARS.find(car => car.visual === search.model);

        if (carsearch) {
          payload.car_model = carsearch.value;
        }
      }
    }

    setFormData(payload);

    // setSource(_source);
    setSending(false);
    setFailed(false);
    setSuccess(false);
    setValid(false);

  };

  useEffect(() => {
    if (selectedDealer) {
      const { properties: { name, user_properties: { sap_dealer_code } } } = selectedDealer;

      setFormData({
        ...formData,
        dealer: name,
        dealer_code: sap_dealer_code,
      });
    }
  }, [selectedDealer]);
  let genk_locations = {
    'place_ids': ['ChIJ-Rj7xC3fwEcR3ytuiIUOBfQ', 'ChIJc56hw9PewEcRUMEDGV6RaJw'],
    'location': {
      lat: 50.977547,
      lng: 5.547458,
    },
  };
  useEffect(() => {
    if (!prediction) { return; }

    if (genk_locations.place_ids.includes(prediction.place_id)) {
      prediction.location = genk_locations.location;
    }

    getDealersFromLocation(prediction.location, formData.car_model);
  }, [prediction]);

  useEffect(() => {
    setValid(form.current.checkValidity() || formData.dealer);
  }, [formData]);

  useEffect(() => {
    reset();
  }, []);

  useLayoutEffect(() => {
    if (params.source !== renderedSource) {
      setFormPanelVisible(false);
    }
  }, [params.source, renderedSource]);

  useEffect(() => {
    if (params.source === renderedSource) {
      setFormPanelVisible(true);
      return undefined;
    }

    const timeoutId = window.setTimeout(() => {
      setRenderedSource(params.source);
      window.requestAnimationFrame(() => {
        setFormPanelVisible(true);
      });
    }, FORM_PANEL_FADE_MS);

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [params.source, renderedSource]);

  useEffect(() => {
    if (rangepdfPrevSourceRef.current === params.source) {
      return undefined;
    }

    rangepdfPrevSourceRef.current = params.source;

    const isMobile = () => !window.matchMedia(mediaQuery).matches;
    if (!isMobile()) {
      return undefined;
    }

    const anchor = formTopAnchorRef.current;
    if (!anchor) {
      return undefined;
    }

    const scrollToFormTop = () => {
      const active = document.activeElement;
      if (active && typeof active.blur === 'function') {
        active.blur();
      }

      const pageRoot = anchor.closest('.page--rangepdf');
      const headerEl = pageRoot?.querySelector(':scope > header');
      const gap = 16;
      const anchorRect = anchor.getBoundingClientRect();
      const anchorTopDoc = anchorRect.top + window.scrollY;

      let offsetBelowViewportTop = gap;
      if (headerEl) {
        const hr = headerEl.getBoundingClientRect();
        const headerStillVisible = hr.bottom > gap && hr.top < window.innerHeight * 0.85;
        if (headerStillVisible) {
          offsetBelowViewportTop = hr.bottom + gap;
        }
      }

      const targetY = Math.max(0, anchorTopDoc - offsetBelowViewportTop);
      window.scrollTo({
        top: targetY,
        behavior: 'smooth',
      });
    };

    window.scrollTo({ top: 0, behavior: 'smooth' });

    let refineTimerId;
    const mainTimerId = window.setTimeout(() => {
      scrollToFormTop();
      refineTimerId = window.setTimeout(scrollToFormTop, 50);
    }, MOBILE_SCROLL_TO_FORM_AFTER_MS);

    return () => {
      window.clearTimeout(mainTimerId);
      window.clearTimeout(refineTimerId);
    };
  }, [params.source, mediaQuery]);

  useEffect(() => {
    const media = window.matchMedia(mediaQuery)
    if (media.matches !== isDesktop) {
      setIsDesktop(media.matches)
    }
    const handleChange = () => {
      setIsDesktop(media.matches)
    }
    media.addEventListener("change", handleChange)
    return () => media.removeEventListener("change", handleChange)
  }, [isDesktop, mediaQuery, setIsDesktop])

  useEffect(() => {
    if (!success) { return; }
    if (!voucherLink?.current) { return; }

    voucherLink.current.click();
  }, [success, voucherLink]);

  useEffect(() => {
    filterCars();
  }, [source]);

  // Force default car to EV2 on testdrive
  useEffect(() => {
    if (source === RANGEPDF.testdrive) {
      setFormData(_formData => ({
        ..._formData,
        car_model: 'EV2',
      }));
    }
  }, [source, formData.car_model]);

  function safeEncodeURL(url = '') {
    return url.includes('%') ? url : encodeURI(url);
  }

  // Initialize Google Places Autocomplete service when API is loaded
  useEffect(() => {
    const initAutocompleteService = () => {
      if (window.google && window.google.maps && window.google.maps.places) {
        autocompleteService = new window.google.maps.places.AutocompleteService();
        if (CONFIG.DEBUG) { console.log('Google Places Autocomplete service initialized'); }
      }
    };

    const handleGoogleMapsLoaded = () => {
      initAutocompleteService();
    };

    // Check if Google Maps API is already loaded
    if (window.google && window.google.maps && window.google.maps.places) {
      initAutocompleteService();
    } else {
      // Listen for the custom event when Google Maps loads
      window.addEventListener('googleMapsLoaded', handleGoogleMapsLoaded);

      // Also check periodically as fallback
      const checkGoogleMaps = setInterval(() => {
        if (window.google && window.google.maps && window.google.maps.places) {
          initAutocompleteService();
          clearInterval(checkGoogleMaps);
        }
      }, 100);

      // Cleanup interval after 10 seconds
      setTimeout(() => {
        clearInterval(checkGoogleMaps);
      }, 10000);

      // Cleanup event listener
      return () => {
        window.removeEventListener('googleMapsLoaded', handleGoogleMapsLoaded);
      };
    }
  }, []);

  return (
    <>
      <Page
        section
        name="rangepdf"
        chat
        footer
        fixedHeader={showBackgroundImage}
        lightHeader={showBackgroundImage}
        dlLabel={RANGEPDF[source]}
        dlModel={model}
        disableScrollToTop
        className={!showBackgroundImage ? 'dark' : ''}
      >
        <div className="rangepdf__wrapper">
          <form className="rangepdf__form" onSubmit={onSubmit} noValidate ref={form}>
            <div className="rangepdf__radios mb--5" ref={formTopAnchorRef}>
              <Input type="radio" disabled={sending} id="quote" data-route={`${prefix}${ROUTES.rangepdfHints}`} wrapperClassName="rangepdf__radio p--3 bold" value={RANGEPDF.hints} label={<><span><FormattedMessage id="rangepdf.label.hints" /></span></>} name="source" checked={source === RANGEPDF.hints} onChange={onSourceChange} />
              <Input type="radio" disabled={sending} id="testdrive" data-route={`${prefix}${ROUTES.rangepdfTestdrive}`} wrapperClassName="rangepdf__radio p--3 bold" value={RANGEPDF.testdrive} label={<><span><FormattedMessage id="rangepdf.label.testdrive" /></span></>} name="source" checked={source === RANGEPDF.testdrive} onChange={onSourceChange} />
              <Input type="radio" disabled={sending} id="code" data-route={`${prefix}${ROUTES.rangepdfCode}`} wrapperClassName="rangepdf__radio p--3 bold" value={RANGEPDF.code} label={<><span><FormattedMessage id="rangepdf.label.code" /></span></>} name="source" checked={source === RANGEPDF.code} onChange={onSourceChange} />
            </div>

            {/* showPromo && <PromoOffer content={'promo.content.form'} showLegal={true} /> */}

            <div className={`rangepdf__form-panel${formPanelVisible ? '' : ' rangepdf__form-panel--hidden'}`}>

              {renderedSource === RANGEPDF.testdrive ? (
                <p className="p--0 mt--10 mb--10 message"><FormattedMessage id="rangepdf.testdrive.message" /></p>
              ) : null}

              {renderedSource === RANGEPDF.hints ? (
                <>
                  <p className="p--0 mt--10 mb--10 message"><FormattedMessage id="rangepdf.hints.message" /></p>
                </>
              ) : null}

              {renderedSource === RANGEPDF.code ? (
                <p className="p--0 mt--10 mb--10 message"><FormattedMessage id="rangepdf.code.message" /></p>
              ) : null}

              {/* Testdrive */}
              {
                renderedSource === RANGEPDF.testdrive && (
                  <>
                    <Select
                      id="car_model"
                      disabled={renderedSource === RANGEPDF.testdrive}
                      name="car_model"
                      wrapperClassName="mb--5"
                      value={formData.car_model}
                      required
                      options={filteredCars}
                      onChange={onChange}
                      className={carPlaceholderShown ? "placeholder-shown" : ""}
                    />
                    <h3 className="p--1 bold mb--2"><FormattedMessage id="rangepdf.testdrive.subtitle.personal" /></h3>
                    <Select
                      id="gender"
                      name="gender"
                      wrapperClassName="mb--5"
                      options={genders}
                      value={formData.gender}
                      required
                      onChange={onChange}
                      errorMessage={intl.formatMessage({ id: 'rangepdf.gender.error' })}
                      className={genderPlaceholderShown ? "placeholder-shown" : ""}
                    />
                    <Input
                      disabled={sending}
                      label={<FormattedMessage id="rangepdf.firstname" />}
                      wrapperClassName="mb--5"
                      labelAfter
                      placeholder={intl.formatMessage({ id: 'rangepdf.firstname' })}
                      id="first_name"
                      name="first_name"
                      required
                      onChange={onChange}
                      value={formData.first_name}
                      errorMessage={intl.formatMessage({ id: 'rangepdf.firstname.error' })}
                    />
                    <Input
                      disabled={sending}
                      label={<FormattedMessage id="rangepdf.lastname" />}
                      wrapperClassName="mb--5"
                      labelAfter
                      placeholder={intl.formatMessage({ id: 'rangepdf.lastname' })}
                      id="last_name"
                      name="last_name"
                      required
                      onChange={onChange}
                      value={formData.last_name}
                      errorMessage={intl.formatMessage({ id: 'rangepdf.lastname.error' })}
                    />
                    <Input
                      disabled={sending}
                      type="email"
                      label={<FormattedMessage id="rangepdf.email" />}
                      wrapperClassName="mb--5"
                      labelAfter
                      placeholder={intl.formatMessage({ id: 'rangepdf.email' })}
                      id="email"
                      name="email"
                      required
                      onChange={onChange}
                      value={formData.email}
                      errorMessage={intl.formatMessage({ id: 'rangepdf.email.error' })}
                    />
                    <Input
                      disabled={sending}
                      type="tel"
                      label={<FormattedMessage id="rangepdf.phone" />}
                      wrapperClassName="mb--5"
                      labelAfter
                      placeholder={intl.formatMessage({ id: 'rangepdf.phone' })}
                      id="phone"
                      name="phone_number"
                      required
                      onChange={onChange}
                      minLength="5"
                      pattern="[+]?[0-9]+"
                      value={formData.phone_number}
                      errorMessage={intl.formatMessage({ id: 'rangepdf.phone.error' })}
                    />

                    <Input
                      disabled={sending}
                      type="text"
                      label={<FormattedMessage id="rangepdf.company" />}
                      wrapperClassName="mb--5"
                      labelAfter
                      placeholder={intl.formatMessage({ id: 'rangepdf.company' })}
                      id="company"
                      name="company"
                      onChange={onChange}
                      value={formData.company}
                      errorMessage={intl.formatMessage({ id: 'rangepdf.company.error' })}
                    />
                    {!dealer ? (
                      <>
                        <h3 className="p--1 bold mb--2"><FormattedMessage id="rangepdf.subtitle.dealer" /></h3>
                        <Input
                          disabled={sending}
                          type="text"
                          label={<FormattedMessage id="rangepdf.dealer" />}
                          wrapperClassName="mb--5"
                          labelAfter
                          placeholder={intl.formatMessage({ id: 'rangepdf.dealer' })}
                          id="location"
                          name="location"
                          required
                          onChange={onLocationChange}
                          value={formData.location}
                          hasError={formData.location && !selectedDealer}
                          errorMessage={intl.formatMessage({ id: 'rangepdf.dealer.error' })}
                        >
                          <div className="predictions">
                            {predictions.map((prediction, i) => {
                              return (
                                <div className="prediction" key={`prediction-${i}`} onClick={() => onPredictionClick(prediction)}>
                                  {prediction.description}
                                </div>
                              );
                            })}
                          </div>
                        </Input>
                      </>
                    ) : null}

                    {selectedDealer ? (<Button onClick={() => resetDealer()} mode="naked" size="small" underline><FormattedMessage id="rangepdf.dealer.reset" /></Button>) : null}


                    {prediction || dealer ? (<h3 className="p--1 bold mb--2"><FormattedMessage id="rangepdf.dealer.title" /></h3>) : null}
                    <div className="dealers">
                      {selectedDealer ? (
                        <div className={`dealer dealer--active`}>
                          <div className="dealer__meta">
                            <p className="p--1 bold mb--2">{selectedDealer.properties.name}</p>
                            <p className="p--1 mb--0">{selectedDealer.properties.address.city}</p>
                          </div>
                          {selectedDealer.properties.distance ? (
                            <div className="dealer__distance">
                              <p className="p--1">
                                <FormattedNumber
                                  value={Math.ceil(selectedDealer.properties.distance * 100 / 1000) / 100}
                                  // eslint-disable-next-line
                                  style="unit"
                                  unit="kilometer"
                                  unitDisplay="narrow"
                                />
                              </p>
                            </div>
                          ) : null}
                        </div>
                      ) : dealers.map((dealer, i) => (
                        <div className={`dealer${selectedDealer && selectedDealer.properties.user_properties.sap_dealer_code === dealer.properties.user_properties.sap_dealer_code ? ' dealer--active' : ''}`} onClick={() => onDealerClick(dealer)} key={`${dealer}-${dealer.properties.store_id}-${i}`}>
                          <div className="dealer__meta">
                            <p className="p--1 bold mb--2">{dealer.properties.name}</p>
                            <p className="p--1 mb--0">{dealer.properties.address.city}</p>
                          </div>
                          <div className="dealer__distance">
                            <p className="p--1">
                              <FormattedNumber
                                value={dealer.properties.distance}
                                // eslint-disable-next-line
                                style="unit"
                                unit="kilometer"
                                unitDisplay="narrow"
                              />
                            </p>
                          </div>
                        </div>
                      ))}
                    </div>

                    <p className="p--3 fc--text-legal"><FormattedMessage id="rangepdf.legal" values={{ a: chunks => (<a href={intl.formatMessage({ id: 'footer.legal.privacy.link' })} target="_blank" rel="noopener noreferrer">{chunks}</a>) }} /></p>
                    <p className="p--3 fc--text-legal"><FormattedMessage id="rangepdf.optin.legal" /></p>


                    <Input disabled={sending} type="checkbox" id="keep_informed" name="keep_informed" label={<FormattedMessage id="rangepdf.optin" />} onChange={onCheck} checked={formData.keep_informed} />
                    <Input
                      className="p--0"
                      disabled={sending}
                      type="checkbox"
                      id="rangepdf_accept_privacy_hints"
                      name="accept_privacy"
                      required
                      label={(
                        <FormattedMessage
                          id="rangepdf.hints.optin2"
                          values={{
                            a: (chunks) => (
                              <a href={intl.formatMessage({ id: 'footer.legal.privacy.link' })} target="_blank" rel="noopener noreferrer">{chunks}</a>
                            ),
                          }}
                        />
                      )}
                      onChange={onCheck}
                      checked={formData.accept_privacy}
                    />
                  </>
                )
              }

              {/* Hints */}
              {
                renderedSource === RANGEPDF.hints && (
                  <>
                    {/* <h3 className="p--1 bold mb--2"><FormattedMessage id="rangepdf.hints.subtitle" /></h3> */}
                    <Input
                      disabled={sending}
                      label={<FormattedMessage id="rangepdf.firstname" />}
                      wrapperClassName="mb--5"
                      labelAfter
                      placeholder={intl.formatMessage({ id: 'rangepdf.firstname' })}
                      id="first_name"
                      name="first_name"
                      required
                      onChange={onChange}
                      value={formData.first_name}
                      errorMessage={intl.formatMessage({ id: 'rangepdf.firstname.error' })}
                    />
                    <Input
                      disabled={sending}
                      label={<FormattedMessage id="rangepdf.lastname" />}
                      wrapperClassName="mb--5"
                      labelAfter
                      placeholder={intl.formatMessage({ id: 'rangepdf.lastname' })}
                      id="last_name"
                      name="last_name"
                      required
                      onChange={onChange}
                      value={formData.last_name}
                      errorMessage={intl.formatMessage({ id: 'rangepdf.lastname.error' })}
                    />
                    <Input
                      disabled={sending}
                      type="email"
                      label={<FormattedMessage id="rangepdf.email" />}
                      wrapperClassName="mb--5"
                      labelAfter
                      placeholder={intl.formatMessage({ id: 'rangepdf.email' })}
                      id="email"
                      name="email"
                      required
                      onChange={onChange}
                      value={formData.email}
                      errorMessage={intl.formatMessage({ id: 'rangepdf.email.error' })}
                    />
                    <Input className="p--0" disabled={sending} type="checkbox" id="rangepdf_keep_informed_hints" name="keep_informed" label={<FormattedMessage id="rangepdf.hints.optin" />} onChange={onCheck} checked={formData.keep_informed} />
                    <Input
                      className="p--0"
                      disabled={sending}
                      type="checkbox"
                      id="rangepdf_accept_privacy_hints"
                      name="accept_privacy"
                      required
                      label={(
                        <FormattedMessage
                          id="rangepdf.hints.optin2"
                          values={{
                            a: (chunks) => (
                              <a href={intl.formatMessage({ id: 'footer.legal.privacy.link' })} target="_blank" rel="noopener noreferrer">{chunks}</a>
                            ),
                          }}
                        />
                      )}
                      onChange={onCheck}
                      checked={formData.accept_privacy}
                    />
                  </>
                )
              }


              {/* Code */}
              {
                renderedSource === RANGEPDF.code && (
                  <>
                    <Input
                      disabled={sending}
                      label={<FormattedMessage id="rangepdf.code" />}
                      wrapperClassName="mb--5"
                      labelAfter
                      placeholder={intl.formatMessage({ id: 'rangepdf.code' })}
                      id="code"
                      name="code"
                      required
                      onChange={onChange}
                      value={formData.code}
                      errorMessage={intl.formatMessage({ id: 'rangepdf.code.error' })}
                    />
                    <Select
                      id="gender"
                      name="gender"
                      wrapperClassName="mb--5"
                      options={genders}
                      value={formData.gender}
                      required
                      onChange={onChange}
                      errorMessage={intl.formatMessage({ id: 'rangepdf.gender.error' })}
                      className={genderPlaceholderShown ? "placeholder-shown" : ""}
                    />
                    <Input
                      disabled={sending}
                      label={<FormattedMessage id="rangepdf.firstname" />}
                      wrapperClassName="mb--5"
                      labelAfter
                      placeholder={intl.formatMessage({ id: 'rangepdf.firstname' })}
                      id="first_name"
                      name="first_name"
                      required
                      onChange={onChange}
                      value={formData.first_name}
                      errorMessage={intl.formatMessage({ id: 'rangepdf.firstname.error' })}
                    />
                    <Input
                      disabled={sending}
                      label={<FormattedMessage id="rangepdf.lastname" />}
                      wrapperClassName="mb--5"
                      labelAfter
                      placeholder={intl.formatMessage({ id: 'rangepdf.lastname' })}
                      id="last_name"
                      name="last_name"
                      required
                      onChange={onChange}
                      value={formData.last_name}
                      errorMessage={intl.formatMessage({ id: 'rangepdf.lastname.error' })}
                    />
                    <Input
                      disabled={sending}
                      type="email"
                      label={<FormattedMessage id="rangepdf.email" />}
                      wrapperClassName="mb--5"
                      labelAfter
                      placeholder={intl.formatMessage({ id: 'rangepdf.email' })}
                      id="email"
                      name="email"
                      required
                      onChange={onChange}
                      value={formData.email}
                      errorMessage={intl.formatMessage({ id: 'rangepdf.email.error' })}
                    />
                    <Input
                      disabled={sending}
                      type="tel"
                      label={<FormattedMessage id="rangepdf.phone" />}
                      wrapperClassName="mb--5"
                      labelAfter
                      placeholder={intl.formatMessage({ id: 'rangepdf.phone' })}
                      id="phone"
                      name="phone_number"
                      required
                      onChange={onChange}
                      minLength="5"
                      pattern="[+]?[0-9]+"
                      value={formData.phone_number}
                      errorMessage={intl.formatMessage({ id: 'rangepdf.phone.error' })}
                    />
                  </>
                )
              }




            </div>

            <div className="form__actions mt--5 rangepdf__button_submit">
              <Button type="submit" disabled={!valid || sending}><FormattedMessage id={source === RANGEPDF.testdrive ? "rangepdf.submit.testdrive" : source === RANGEPDF.code ? "rangepdf.submit.code" : "rangepdf.submit.hints"} /></Button>
            </div>

            {success ? (
              <Info page visible className="center">
                <h4 className="heading heading--4 mb--2"><FormattedMessage id="rangepdf.successtitle" /></h4>
                <p className="p--2 mt--0 mb--2"><FormattedMessage id="rangepdf.successmessage" /></p>
                { /*source === RANGEPDF.hints && showPromo ? <p className="p--2 mt--0 mb--2"><FormattedMessage id="promo.contact.vouchertext" values={{ voucher: (<a href={voucherUrl} target="_blank" rel="noopener noreferrer" ref={voucherLink} download="Kia voucher">{ intl.formatMessage({ id: 'promo.contact.voucherlabel' }) }</a>) }} /></p> : null*/}
                <Button type="button" size="small" color="primary" className="success__link mt--2" onClick={() => window.location.reload()}><FormattedMessage id="back.back" /></Button>
              </Info>
            ) : null}

            {failed ? (
              <Info page visible close onClose={reset}>
                <h4 className="heading heading--4 fc--negative"><FormattedMessage id="rangepdf.errortitle" /></h4>
                <p className="p--2"><FormattedMessage id="rangepdf.errormessage" /></p>
              </Info>
            ) : null}
          </form>

          <div className='col col-visual'>
            <div className="logo__wrapper">
              <p className="logo__text"><FormattedMessage id="rangepdf.logo.text" /></p>
              <img className="logo__wrapper__title" src="/graphics/the-range-pdf.svg" alt="Kia" />
              <div className="logo__wrapper__item">
                <span>BY</span>
                <img src="/graphics/kia-logo-white.svg" alt="Kia" />
              </div>
              <h2><FormattedMessage id="rangepdf.title" /></h2>
              <p
                dangerouslySetInnerHTML={{
                  __html: intl.formatMessage({ id: 'rangepdf.subtitle' }).replace(/\n\r?/g, '<br />'),
                }}
              />
              <p><FormattedMessage id="rangepdf.howto" /></p>
              <Button mode="outline" color="transparent" href={intl.formatMessage({ id: 'rangepdf.openpdf.url' })} className="bold button--openpdf button--openinstructionvideo" size="small"><FormattedMessage id="rangepdf.openinstructionvideo" /></Button>
              <Button mode="outline" color="transparent" href={intl.formatMessage({ id: 'rangepdf.openpdf.url' })} className="bold button--openpdf" size="small"><FormattedMessage id="rangepdf.openpdf" /></Button>
            </div>
            {
              isDesktop && (
                <picture>
                  <img src={"/graphics/visual-rangepdf-ev2.png"} alt={"EV2"}></img>
                </picture>
              )
            }
          </div>

          {
            !isDesktop && (
              <picture>
                <img src={"/graphics/visual-rangepdf-ev2.png"} alt={"EV2"}></img>
              </picture>
            )
          }
        </div>

        {sending ? (<Loading page />) : null}
      </Page>
    </>
  );
}
